/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPmiCapture = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.138 15.157v1.484c-.392.205-.83.36-1.316.462a6.897 6.897 0 0 1-1.554.168c-1.568 0-2.772-.462-3.612-1.386-.83-.924-1.246-2.259-1.246-4.004 0-1.073.196-1.993.588-2.758a4.209 4.209 0 0 1 1.708-1.764c.746-.42 1.628-.63 2.646-.63.448 0 .891.051 1.33.154.438.103.816.247 1.134.434v1.47a8.722 8.722 0 0 0-1.274-.42 4.783 4.783 0 0 0-1.078-.126c-1.046 0-1.853.322-2.422.966-.57.635-.854 1.526-.854 2.674 0 1.241.28 2.198.84 2.87.57.663 1.381.994 2.436.994.41 0 .826-.047 1.246-.14.43-.093.905-.243 1.428-.448zm6.318 1.932-.238-1.092a2.89 2.89 0 0 1-1.022.938 2.88 2.88 0 0 1-1.358.322c-.756 0-1.358-.21-1.806-.63-.438-.42-.658-.99-.658-1.708 0-.765.28-1.367.84-1.806.56-.439 1.325-.658 2.296-.658h1.386v-.35c0-.467-.098-.784-.294-.952-.196-.168-.541-.252-1.036-.252-.737 0-1.577.173-2.52.518v-1.33a6.414 6.414 0 0 1 1.274-.378c.476-.093.943-.14 1.4-.14 1.914 0 2.87.84 2.87 2.52v4.998h-1.134zm-2.268-1.12c.346 0 .672-.089.98-.266.308-.187.56-.443.756-.77v-1.386h-1.218c-1.13 0-1.694.41-1.694 1.232 0 .373.103.667.308.882.205.205.495.308.868.308z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgPmiCapture as PmiCapture };
